import React, { useState, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import baseURL from '../../../Apiurs/Apiurls';
import { AuthContext } from '../../../AuthContext/Authcontext';
import Navbar from '../../../Shared/AdminNavbar/Navbar';
import './Leads.css';

function BudgetQuotationForm() {
  const location = useLocation();
  const navigate = useNavigate();
  const { authToken } = useContext(AuthContext);
  
  const lead = location.state?.lead || {};
  
  const [email, setEmail] = useState(lead.email || '');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [collapsed, setCollapsed] = useState(false);

  const handleFileChange = (e) => {
    console.log('File selected:', e.target.files[0]?.name);
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!file) {
      console.error('No file selected');
      setMessage('Please select a file');
      return;
    }

    console.log('Submitting quotation form:', { email, leadId: lead.id, leadName: lead.lead_name });
    setLoading(true);
    setMessage('');

    const formData = new FormData();
    formData.append('email', email);
    formData.append('quotation', file);
    formData.append('leadId', lead.id);
    formData.append('leadName', lead.lead_name);

    try {
      const response = await axios.post(
        `${baseURL}/api/send-budget-quotation`,
        formData,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      console.log('Quotation sent successfully:', response.data);
      setMessage(response.data.message); // Updated to handle new response format
      setTimeout(() => {
        console.log('Navigating to /adminleads');
        navigate('/adminleads');
      }, 2000);
    } catch (error) {
      console.error('Error sending quotation:', error.response?.data || error.message);
      setMessage(error.response?.data?.error || 'Failed to send quotation');
    } finally {
      setLoading(false);
      console.log('Form submission completed, loading set to false');
    }
  };

  const handleCancel = () => {
    console.log('Cancel button clicked, navigating to /adminleads');
    navigate('/adminleads');
  };

  return (
    <div className="AdminLeadscontainer">
      <Navbar onToggleSidebar={setCollapsed} />
      <div className={`AdminLeads ${collapsed ? 'collapsed' : ''}`}>
        <div className="AdminLeads-container mb-5">
          <div className="BudgetQuotationForm">
            <div className="card">
              <div className="card-header bg-primary text-white">
                <h4 className="mb-0">Send Budget Quotation</h4>
              </div>
              <div className="card-body">
                <div className="row mb-3">
                  <div className="col-md-6">
                    <strong>Lead Name:</strong> {lead.lead_name || 'N/A'}
                  </div>
                  <div className="col-md-6">
                    <strong>Business Name:</strong> {lead.business_name || 'N/A'}
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col-md-6">
                    <strong>Lead ID:</strong> Lead00{lead.id || 'N/A'}
                  </div>
                  <div className="col-md-6">
                    <strong>Current Email:</strong> {lead.email || 'N/A'}
                  </div>
                </div>

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label htmlFor="email" className="form-label">
                      <strong>Recipient Email *</strong>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                      placeholder="Enter recipient email address"
                    />
                  </div>
                  
                  <div className="mb-4">
                    <label htmlFor="quotation" className="form-label">
                      <strong>Quotation File *</strong>
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      id="quotation"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.png"
                      onChange={handleFileChange}
                      required
                    />
                    <div className="form-text">
                      Supported formats: PDF, Word, Excel, JPG, PNG (Max size: 10MB)
                    </div>
                  </div>

                  {message && (
                    <div className={`alert ${message.includes('successfully') ? 'alert-success' : 'alert-danger'} mb-3`}>
                      {message}
                    </div>
                  )}

                  <div className="d-flex gap-2 justify-content-end">
                    <button 
                      type="button" 
                      className="btn btn-secondary" 
                      onClick={handleCancel}
                      disabled={loading}
                    >
                      Cancel
                    </button>
                    <button 
                      type="submit" 
                      className="btn btn-primary" 
                      disabled={loading}
                    >
                      {loading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Sending...
                        </>
                      ) : (
                        'Send Quotation'
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BudgetQuotationForm;